module.exports = __webpack_public_path__ + "img/fabric-trading.4503faf5.svg";